import React, {Component} from 'react'
import '../../static/css/style.scss'
class Notdata extends Component {
	render() {
		return (
			<div className={'nodata'}>
				<img src={require('../../static/images/zanwuneirong.png')} alt=""/>
				<div className={'nodata_txt'}>暂无内容</div>
			</div>
		)
	}
}

export default Notdata